export interface ITypeChamp {
    id?: string;
    code: string;
    canHaveMultipleValues: boolean;
    hasPredifinedValues: boolean;

}

export enum ETypeChamp {
    SELECT = 'select',
    MULTISELECT = 'multiselect',
    TEXT = 'text',
    PRIX = 'prix',
    DATE = 'date',
    RADIO = 'radio',
    CHECKBOX = 'checkbox',
    TEXTAREA = 'textarea',
    FILE = 'file',
    SELECTCOULEUR = 'select_couleur',
    SECTION = 'section',
    TABLEAU = 'tableau',
    SPACER = 'spacer'
}

export class TypeChamp implements ITypeChamp {

    id: string;
    code: string;
    canHaveMultipleValues: boolean;
    hasPredifinedValues: boolean;

    constructor(champType: ITypeChamp) {
        this.id = champType.id;
        this.code = champType.code;
        this.canHaveMultipleValues = champType.canHaveMultipleValues;
        this.hasPredifinedValues = champType.hasPredifinedValues;
    }

    static fromJson(data: any): TypeChamp {
        return new TypeChamp({
            id: data.typ_id,
            code: data.typ_code,
            canHaveMultipleValues: data.typ_has_multiple_values,
            hasPredifinedValues: data.typ_has_predifined_values
        });
    }

}
